import Swiper, { EffectFade, Pagination, Autoplay } from 'swiper';
import Cookies from 'js-cookie';

const throttle = (fn, wait) => {
  let time = Date.now();

  return function () {
    if (time + wait - Date.now() < 0) {
      fn();
      time = Date.now();
    }
  };
};

document.addEventListener('DOMContentLoaded', () => {
  // mobile menu
  const masthead = document.querySelector('.masthead');

  document.querySelectorAll('.mobile-menu-toggle').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      masthead.classList.toggle('toggled');
    });
  });

  // scroll observer
  masthead.classList.toggle('scrolled', window.scrollY > 100);
  window.addEventListener(
    'scroll',
    throttle(() => {
      masthead.classList.toggle('scrolled', window.scrollY > 100);
    }, 30)
  );

  // form floating labels
  document.querySelectorAll('.floating-label').forEach((el) => {
    const span = document.createElement('span');
    span.innerText = el.dataset.label;

    el.querySelector('.wpcf7-form-control-wrap').appendChild(span);
  });

  // footer form success message
  const footerForm = document.querySelector('.mastfoot .wpcf7');
  const footerFormResponse = document.querySelector('.mastfoot--form-response');

  if (footerForm && footerFormResponse) {
    footerForm.addEventListener('wpcf7mailsent', () => {
      footerFormResponse.classList.add('toggled');
    });

    footerFormResponse.addEventListener('click', () => {
      footerFormResponse.remove();
    });
  }

  // contact bubble
  const contactBubbleBtn = document.querySelector('.contact-bubble--btn');
  const contactBubbleContent = document.querySelector('.contact-bubble--content');
  const contactBubbleBtnEmergencyBtn = document.querySelector('.contact-bubble--content-emergency button');

  contactBubbleBtn.addEventListener('click', () => {
    contactBubbleContent.classList.add('toggled');
    document.documentElement.classList.add('scroll-lock');
  });

  contactBubbleContent.addEventListener('click', (e) => {
    if (e.target === contactBubbleContent) {
      contactBubbleContent.classList.remove('toggled');
      document.documentElement.classList.remove('scroll-lock');
    }
  });

  contactBubbleBtnEmergencyBtn.addEventListener('click', () => {
    document.querySelector('.contact-bubble--content-emergency-box').classList.toggle('toggled');
  });

  // global slider

  const globalSlider = document.querySelector('.global-slider');
  if (globalSlider && Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) > 1200) {
    document.documentElement.classList.add('scroll-lock');

    new Swiper('.global-slider--main-slider', {
      modules: [Autoplay, Pagination],
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
      },
      loop: true,
    });

    globalSlider.querySelectorAll('.swiper-slide--main svg').forEach((el) => {
      el.addEventListener('click', () => {
        Cookies.set('global_slider_shown', 1, 30);

        document.documentElement.classList.remove('scroll-lock');

        globalSlider.remove();
      });
    });
  } else {
    document.documentElement.classList.remove('scroll-lock');
  }

  // up arrow
  const upArrow = document.querySelector('.mastfoot--arrow');
  if (upArrow) {
    upArrow.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  if (document.body.classList.contains('home')) {
    // hero img slider

    const heroSliderButtons = document.querySelector('.swiper-buttons');

    const heroImagesSlider = new Swiper('.home-hero--images', {
      loop: true,
      modules: [EffectFade],
      effect: 'fade',
      noSwiping: true,
      noSwipingClass: 'swiper-slide',
      allowTouchMove: false,
    });

    const heroTextSlider = new Swiper('.home-hero--text-wrapper', {
      // loop: true,
      noSwiping: true,
      noSwipingClass: 'swiper-slide',
      allowTouchMove: false,
    });

    if (heroSliderButtons) {
      document.querySelector('.home-hero .swiper-buttons-prev').addEventListener('click', () => {
        heroImagesSlider.slidePrev();
        heroTextSlider.slidePrev();
      });

      document.querySelector('.home-hero .swiper-buttons-next').addEventListener('click', () => {
        heroImagesSlider.slideNext();
        heroTextSlider.slideNext();
      });
    }
  } else if (document.body.classList.contains('page-template-template-contact')) {
    // channels address
    document.querySelector('.page-contact--main-channels address').addEventListener('click', () => {
      document.getElementById('gmap').scrollIntoView({
        behavior: 'smooth',
      });
    });

    // contact form
    const contactForm = document.querySelector('.page-contact--main-form .wpcf7');
    const contactFormResponse = document.querySelector('.page-contact--main-form-response');
    contactForm.addEventListener('wpcf7mailsent', () => {
      contactFormResponse.classList.add('toggled');
    });

    contactFormResponse.addEventListener('click', () => {
      contactFormResponse.remove();
    });

    const contactPageEmergencyBtn = document.querySelector('.page-contact--main-channels-emergency button');
    contactPageEmergencyBtn.addEventListener('click', () => {
      document.querySelector('.page-contact--main-channels-emergency-box').classList.toggle('toggled');
    });

    // map

    // eslint-disable-next-line no-undef
    const center = new google.maps.LatLng(52.2274228, 21.098701);

    const mapOptions = {
      zoom: 17,
      center: center,
      disableDefaultUI: true,
      styles: [
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e9e9e9',
            },
            {
              lightness: 17,
            },
          ],
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5',
            },
            {
              lightness: 20,
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#ffffff',
            },
            {
              lightness: 17,
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#ffffff',
            },
            {
              lightness: 29,
            },
            {
              weight: 0.2,
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff',
            },
            {
              lightness: 18,
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff',
            },
            {
              lightness: 16,
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5',
            },
            {
              lightness: 21,
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dedede',
            },
            {
              lightness: 21,
            },
          ],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              visibility: 'on',
            },
            {
              color: '#ffffff',
            },
            {
              lightness: 16,
            },
          ],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              saturation: 36,
            },
            {
              color: '#333333',
            },
            {
              lightness: 40,
            },
          ],
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [
            {
              color: '#f2f2f2',
            },
            {
              lightness: 19,
            },
          ],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#fefefe',
            },
            {
              lightness: 20,
            },
          ],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#fefefe',
            },
            {
              lightness: 17,
            },
            {
              weight: 1.2,
            },
          ],
        },
      ],
    };

    const mapElement = document.getElementById('gmap');
    // eslint-disable-next-line no-undef
    const map = new google.maps.Map(mapElement, mapOptions);

    // eslint-disable-next-line no-undef
    const marker = new google.maps.Marker({
      // eslint-disable-next-line no-undef
      position: center,
      map: map,
      title: 'Kaga Lux',
    });

    const contentString =
      '<div id="content">' +
      '<div id="siteNotice">' +
      '</div>' +
      '<h1 id="firstHeading" class="firstHeading">KG Lux Zakłady Pralnicze</h1>' +
      '<div id="bodyContent">' +
      '<p style="font-size: 16px;">Władysława Umińskiego 16A, 03-984 Warszawa</p>' +
      '<p style="font-size: 16px;"><a href="https://www.google.com/maps/place/KG+Lux+Sp.+z+o.+o./@52.2274227,21.0986987,15z/data=!4m2!3m1!1s0x0:0x2e8dfa68d085b0a9?sa=X&ved=2ahUKEwic8fW0hYT9AhUjposKHf3VBmQQ_BJ6BAhfEAg" style=" color: #1a73e8;" target="_blank" rel="noopener noreferrer">' +
      'Zobacz wiekszą mapę</a> ' +
      '</p>' +
      '</div>' +
      '</div>';

    // eslint-disable-next-line no-undef
    const infowindow = new google.maps.InfoWindow({
      content: contentString,
    });

    infowindow.open(map, marker);

    marker.addListener('click', () => {
      infowindow.open({
        anchor: marker,
        map,
        shouldFocus: false,
      });
    });
  } else if (document.body.classList.contains('page-template-template-price-offer')) {
    const pricingPopup = document.querySelector('.page-price-offer--individual-pricing-popup');

    document.querySelector('.page-price-offer--individual-pricing-box button').addEventListener('click', (e) => {
      e.preventDefault();

      pricingPopup.classList.add('toggled');
    });

    const pricingForm = document.querySelector('.page-price-offer--individual-pricing-popup .wpcf7');
    const pricingFormResponse = document.querySelector('.page-price-offer--individual-pricing-popup-response');
    pricingForm.addEventListener('wpcf7mailsent', () => {
      pricingFormResponse.classList.add('toggled');
      pricingForm.style.height = 0;
      pricingForm.style.overflow = 'hidden';
    });

    pricingFormResponse.addEventListener('click', () => {
      pricingPopup.classList.remove('toggled');
      pricingFormResponse.classList.remove('toggled');
      pricingForm.style.height = 'auto';
      pricingForm.style.overflow = 'visible';
    });

    pricingPopup.addEventListener('click', (e) => {
      if (e.target === pricingPopup) {
        pricingPopup.classList.remove('toggled');
        pricingFormResponse.classList.remove('toggled');
        pricingForm.style.height = 'auto';
        pricingForm.style.overflow = 'visible';
      }
    });
  }
});
